import React from "react";
import SupportEmail from "../components/SupportEmail";

const FAQ = () => {
  return (
    <>
      <div className="security-container">
        <h1>Frequently Asked Questions</h1>

        <div className="faq-list" style={{ marginTop: '30px' }}>
          <div className="faq-item">
            <h4>Why don't you require an email address?</h4>
            <p>We believe in true privacy. By not collecting email addresses, we eliminate a major privacy risk and simplify account creation. Your Login ID and Recovery Key are all you need.</p>
          </div>
          <div className="faq-item">
            <h4>How do daily tokens work?</h4>
            <p>Each account receives a daily allocation of tokens used for sending messages. This ensures fair usage and optimal performance for all users. Your tokens reset automatically every 24 hours.</p>
          </div>
          <div className="faq-item">
            <h4>What if I lose my Login ID and Recovery Key?</h4>
            <p>Unfortunately, we cannot recover lost credentials since we don't store any personal information. This is by design for maximum privacy. Please save your credentials securely.</p>
          </div>
          <div className="faq-item">
            <h4>Can I use this on multiple devices?</h4>
            <p>Yes! Your Login ID works across all supported platforms - web, mobile, and desktop applications. Your daily tokens are shared across all devices.</p>
          </div>
          <div className="faq-item">
            <h4>Why do you collect device fingerprints and IP?</h4>
            <p>
              IP addresses and device identifiers are processed strictly for abuse mitigation and system
              integrity. Login IDs and messages are encrypted and hashed in our database, and our
              architecture is designed to maintain separation between abuse-prevention metadata and
              encrypted account data.
            </p>
            <p style={{ marginTop: '12px' }}>
              Omega Void™ does not use device or IP information to link activity to personal identity or
              create behavioral tracking profiles.
            </p>
          </div>
        </div>
      </div>
      <SupportEmail />
    </>
  );
};

export default FAQ;
